import * as promotions from 'src/api/promotion'
import {
  SET_PROMOTION,
  SET_PROMOTION_HELPERS
} from 'src/store/mutation-types'
import router from 'src/router'

const setPromotion = ({commit}, data) => {
  commit(SET_PROMOTION, data)
}

const getPromotion = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  promotions.getPromotions(configs.id, configs.params).then(response => {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, {root: true})
        commit(SET_PROMOTION, response.data)
        break
      case 404:
        dispatch('toggleLoadding', false, {root: true})
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Mã giảm giá không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
        router.push({name: 'promotion'})
        break
      default:
        dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const getPromotionHelpers = ({commit}, configs) => {
  promotions.getPromotionHelpers().then(response => {
    commit(SET_PROMOTION_HELPERS, response)
  })
}

export default{
  setPromotion,
  getPromotion,
  getPromotionHelpers
}



// WEBPACK FOOTER //
// ./src/components/promotion/store/actions.js